import { combineReducers } from "redux";

import tracks from "../modules/tracks/reducer";

export default combineReducers({
    tracks,
});
